<dashboardnav>
    <cradua-cleanupstatus
    [cleanupstatuss]="cleanupstatuss$ | async"
    (cleanupstatus)="onSubmitCleanUpStatus($event)"
    (deleteCleanUpStatusEvent)="onDeleteCleanUpStatus($event)"
    *ngIf="(isLoadingCleanUpStatus$ | async ) === false"
    >
  </cradua-cleanupstatus>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingCleanUpStatus$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
